import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { LicenseTypesComponent } from './manage-license-types.component';

const routes: Routes = [
  { path: '', component: LicenseTypesComponent, data: { title: 'Manage License Types' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageLicenseTypesRoutingModule {}

@NgModule({
  imports: [
    ManageLicenseTypesRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [LicenseTypesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageLicenseTypesModule {}
